module.exports = __webpack_public_path__ + "img/logo_icon.4c350730.png";